export const lightTheme = {
  '--w-rjv-color': 'hsl(240 10% 3.9%)',
  '--w-rjv-key-string': 'hsl(240 5.9% 10%)',
  '--w-rjv-background-color': 'transparent',
  '--w-rjv-line-color': 'hsl(240 5.9% 90%)',
  '--w-rjv-arrow-color': 'hsl(240 3.8% 46.1%)',
  '--w-rjv-info-color': 'hsl(240 3.8% 46.1%)',
  '--w-rjv-type-string-color': 'hsl(142 76% 36%)',
  '--w-rjv-type-int-color': 'hsl(221 83% 53%)',
  '--w-rjv-type-float-color': 'hsl(221 83% 53%)',
  '--w-rjv-type-boolean-color': 'hsl(280 68% 60%)',
  '--w-rjv-type-null-color': 'hsl(240 3.8% 46.1%)',
};

export const darkTheme = {
  '--w-rjv-color': 'hsl(0 0% 98%)',
  '--w-rjv-key-string': 'hsl(0 0% 98%)',
  '--w-rjv-background-color': 'transparent',
  '--w-rjv-line-color': 'hsl(240 3.7% 15.9%)',
  '--w-rjv-arrow-color': 'hsl(240 5% 64.9%)',
  '--w-rjv-info-color': 'hsl(240 5% 64.9%)',
  '--w-rjv-type-string-color': 'hsl(142 76% 50%)',
  '--w-rjv-type-int-color': 'hsl(221 83% 65%)',
  '--w-rjv-type-float-color': 'hsl(221 83% 65%)',
  '--w-rjv-type-boolean-color': 'hsl(280 68% 70%)',
  '--w-rjv-type-null-color': 'hsl(240 5% 64.9%)',
};
